let _ = require("ES/lib/lodash");
let Balboa = require("ES/services/Balboa");
let esUtils = require("ES/utils/esUtils");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

let toDate = function(d){
	return !_.isString(d) || d === "1950-01-01T00:00:00" ? null : esUtils.convertFromISO8601(d);
};

let balboa2JS_shortevent = function(shortevent){
	shortevent.stagetime_starttime = toDate(shortevent.stagetime_starttime);
	shortevent.stagetime_stoptime = toDate(shortevent.stagetime_stoptime);
	return shortevent;
};


module.exports.init = function(){

	RadioService("EventSearch_search", function(params, callback){
		if(!_.isPlainObject(params)){
			return;
		}
		let api_params = _.assign({
			//filter to selected speaker(s)
			speaker_ids: esUtils.cleanup_ids(_.flattenDeep([params.sids, params.speaker_ids]))
		}, params);
		if(/^\s*[0-9]+\s*/.test(params.searchterm)){//if it's an EID search
			delete api_params.speaker_ids;//don't filter by speaker
		}
		Balboa.api("/search/event", api_params, function(data){
			callback(null, _.map(data.data, balboa2JS_shortevent));
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});

};



// WEBPACK FOOTER //
// ./src/services/EventSearch.js